import { actions } from '../../utils/constants';

export const fetchSomeUsers = filter => ({
    type: actions.ASYNC_FETCH_SOME_USERS,
    payload: filter,
});

export const fetchUserDataByClass = classId => ({
    type: actions.ASYNC_FETCH_USER_DATA,
    payload: { classId },
});

export const fetchUserEnrollments = userId => ({
    type: actions.ASYNC_FETCH_USER_ENROLLMENTS,
    payload: { userId },
});

export const fetchUsers = filter => ({
    type: actions.ASYNC_FETCH_ALL_USERS,
    payload: filter,
});

export const editNewUserInput = ({ target }) => ({
    type: actions.ASYNC_EDIT_NEW_USER,
    payload: { id: target.id, value: target.value },
});

export const toggleFormIsVisible = bool => ({
    type: actions.TOGGLE_SHOW_FORM,
    payload: bool,
});

export const toggleSearchRealmFormIsVisible = bool => ({
    type: actions.TOGGLE_SHOW_FORM_SEARCH_REALMS,
    payload: bool,
});

export const toggleShitchAddRealmFormIsVisible = bool => ({
    type: actions.TOGGLE_SHOW_SWITCH_ADD_REALMS,
    payload: bool,
});

export const checkInfoRealmsUser = ({ email }) => ({
    type: actions.ASYNC_CHECK_INFO_ABOUT_REALMS_USER,
    payload: { email },
});

export const clearcheckInfoRealmsUser = () => ({
    type: actions.CLEAR_CHECK_INFO_ABOUT_REALMS_USER,
});

export const clearNewUserForm = () => ({
    type: actions.CLEAR_NEW_USER,
});

export const createNewUser = () => ({
    type: actions.ASYNC_CREATE_USER,
});

export const uploadAttach = (
    dataUri,
    filename = 'filename',
    mime,
    userId,
    classId,
    callback,
) => ({
    type: actions.UPLOAD_ATTACHMENT,
    payload: { dataUri, filename, mime, userId, classId, callback },
});

export const attachmentClassChoose = (userId, classId, callback) => ({
    type: actions.GETTING_ATTACHMENTS,
    payload: { userId, classId, callback },
});

export const downloadAttach = (userId, classId, attachId, callback) => ({
    type: actions.DOWNLOADING_ATTACH,
    payload: { userId, classId, attachId, callback },
});

export const deletingAttach = (userId, classId, attachId, callback) => ({
    type: actions.DELETING_ATTACH,
    payload: { userId, classId, attachId, callback },
});

export const initEditUser = data => ({
    type: actions.INIT_EDIT_USER,
    payload: { data },
});

export const finishEditUser = callback => ({
    type: actions.FINISH_EDIT_USER,
    payload: { callback },
});

export const createAlertFunc = (typeAlert, title, message, duration) => {
    return {
        type: actions.ASYNC_CREATE_ALERT,
        payload: { type: typeAlert, title, message, duration },
    };
};

export const changeRedirectToUsers = ({ withNewValue }) => {
    return {
        type: actions.CHANGE_REDIRECT_TO_TABLE_USERS,
        payload: withNewValue,
    };
};



// WEBPACK FOOTER //
// ./src/components/users/users.actions.js